// 页面公共样式渲染脚本
(function () {
    var userInfo = sessionStorage.getItem('userInfo')
    var name =  userInfo && JSON.parse(userInfo).mobile
    getRomoteConfig(refreshMenu)
    // var name =  1
    let imgBaseUrl = isHome()?`./`:`../`;
    let homeBtnHtml = isHome()?"":`<span class="btn home-btn" ><img src="${imgBaseUrl}images/common/home.png" alt="" />首页</span>`;


      var header = `<div class="header-contain clearfix">
      <a href="#" class="header-logo fl">
      <img src="${imgBaseUrl}images/common/white_logo.png" alt="银川logo" />
    </a>
    <div class="header-tool fr">
        <span>
        ${name ? `${homeBtnHtml}<span class="btn notice-btn" ><img src="${imgBaseUrl}images/common/notice.png" alt="" />通知</span><span class="btn help-btn" ><img src="${imgBaseUrl}images/common/help.png" alt="" />帮助</span><span class="btn logout-btn"> <img src="${imgBaseUrl}images/common/exit.png" alt="" />退出</span>` : `${homeBtnHtml}<span class="btn help-btn" ><img src="${imgBaseUrl}images/common/help.png" alt="" />帮助</span><span class="btn login-btn" >登录</span>`}
    </div>
  </div>

  </div>`
    var sessionUrls = JSON.parse(sessionStorage.getItem('urls'))
    var sessionCode = sessionUrls && sessionUrls.code;

    var body = `<div class="body-left">
      <div class="left-nav">
        <ul class="layui-nav layui-nav-tree" lay-filter="leftNav" lay-shrink="all">
          <li class="layui-nav-item">
            <a href="javascript:;" class="layui-nav-item-a" >
              <img src="../images/common/water.png" class="nav-item-dt" alt="">
              <span>用水服务</span>
            </a>
            <dl class="layui-nav-child">
              <dd><a class="menu-title" href="./onlinePayment.html">水费查缴</a></dd>
              <dd><a class="menu-title" href="./invoice.html">电子发票</a></dd>
              <dd><a class="menu-title" href="./billDownload.html">账单查询</a></dd>
            </dl>
          </li>
          <li class="layui-nav-item">
            <a href="javascript:;" class="layui-nav-item-a">
              <img src="../images/common/business.png" class="nav-item-dt" alt="">
              <span>业务办理</span>
            </a>
            <dl class="layui-nav-child">
              <dd><a class="menu-title" href="./peopleApply.html">居民用水申请</a></dd>
              <dd><a class="menu-title" href="./compApply.html">企业用水申请</a></dd>
              <dd><a class="menu-title" href="./businessGuide.html">业务指南</a></dd>
              <dd><a class="menu-title" href="./businessQuery.html">业务查询</a></dd>
              <dd><a class="menu-title" href="./waterReport.html?type=4">新装接水</a></dd>
              <dd><a class="menu-title" href="./waterReport.html?type=5">市政绿化</a></dd>
              <dd><a class="menu-title" href="./waterReport.html?type=6">施工临水</a></dd>
              <dd><a class="menu-title" href="./separateAccount.html">分户改造</a></dd>
            </dl>
          </li>
          <li class="layui-nav-item">
            <a href="javascript:;" class="layui-nav-item-a">
              <img src="../images/common/personal.png" class="nav-item-dt" alt="">
              <span>个人中心</span>
            </a>
            <dl class="layui-nav-child">
              <dd><a class="menu-title" href="./accountBinding.html">账号绑定</a></dd>
              <dd><a class="menu-title" href="./waterAnalysis.html">用水分析</a></dd>
              <dd><a class="menu-title" href="./changePassword.html">修改密码</a></dd>
            </dl>
          </li>
          <li class="layui-nav-item">
            <a href="javascript:;" class="layui-nav-item-a">
              <img src="../images/common/pservice.png" class="nav-item-dt" alt="">
              <span>公共服务</span>
            </a>
            <dl class="layui-nav-child">
              <dd><a class="menu-title" href="./leakAndRepairs.html">报修报漏</a></dd>
              <dd><a class="menu-title" href="./complaintreport.html">我要留言</a></dd>
              <dd><a class="menu-title" href="./businessOutlets.html">营业网点</a></dd>
            </dl>
          </li>
        </ul>
      </div>
    </div>`
   
    var footer = `<div class="footer-content">
    <div class="footer-left">
      <p>Copyright @ 2016-2017  银川中铁水务集团有限公司</p>
      <p>
        备案号：
        <a href="http://www.beian.miit.gov.cn/" target="_blank" class="record-number">宁公网安备 64010402000779号</a>
      </p>
    </div>
  </div>`
  
    // 入口
    function main() {
      $('.main-header').prepend(header);
  
      if(window.location.pathname === '' || window.location.pathname === '/') {
        var code = getRouterParams().code
        window.location.href = code ? '/indexNew.html?code=' + code : '/indexNew.html'
      }
  
      if(window.location.pathname.indexOf('/changePassword.html') > -1 && !sessionStorage.getItem('token')) {
        // window.location.href = './login.html'
      }
  
      $('.header-tool .logout-btn').on('click', logout)
      $('.header-tool .register-btn').on('click',{type:"register"}, register)
      $('.header-tool .login-btn').on('click',{type:"login"}, register)
      $('.header-tool .home-btn').on('click', toHome)

      // 首页不添加
      if (window.location.href.indexOf('index') < 0) {
        $('.main-body').prepend(body)
      }
      if(window.location.pathname.indexOf('/login.html') > -1 || window.location.pathname.indexOf('/register.html') > -1) {
        $('.left-userMsg').hide()
      }
      $('.main-footer').prepend(footer)
  
        $('.main-body .home-top .top-left').css('width', '100%')
        // $('.main-body .home-top .top-left>img').css({width: '100%', height: '296px'})
        $('.main-body .home-top .top-right').remove()
        $('.top-menu').remove()
        $('.bannarBackground').remove()
        let LeftNav = [
          ["onlinePayment.html", "invoice.html", "billDownload.html"],
          ["peopleApply.html", "compApply.html", "businessGuide.html", "businessQuery.html", "waterReport.html", "waterReport.html", "waterReport.html", "separateAccount.html"],
          ["accountBinding.html", "waterAnalysis.html", "changePassword.html"],
          ["leakAndRepairs.html", "complaintreport.html", "businessOutlets.html"]
        ]
        // 左边菜单高亮
        setTimeout( function () {
          let href = window.location.pathname, childMenuIndex = null;
          let currentGroup = href.split('/');
          let currentIndex = currentGroup.filter(function(item) {
            return item.indexOf(".html")!== -1
          })
          
          LeftNav.forEach((item, index) => {
            if(currentIndex.length > 0 && item.indexOf(currentIndex[0]) !== -1) {
              childMenuIndex = item.indexOf(currentIndex[0]);
              if(currentIndex[0] === "waterReport.html"){
                let pageParmas = getRouterParams();
                switch(pageParmas.type) {
                  case "5": childMenuIndex +=1;
                  break;
                  case "6": childMenuIndex +=2;
                }
              }
              
              $(".layui-nav-item").eq(index).addClass("layui-nav-itemed")
              $(".layui-nav-item").eq(index).children(".layui-nav-item-a").eq(0).addClass("layui-nav-item-a-active")
              $(".layui-nav-item").eq(index).find(".menu-title").eq(childMenuIndex).addClass("menu-title-active")
              let currentUrl = $(".layui-nav-item-a-active").children(".nav-item-dt").attr("src");
              currentUrl = currentUrl.split(".png")
              $(".layui-nav-item-a-active").children(".nav-item-dt").attr("src",`${currentUrl[0]}_active.png`);
            }
          })
          if(href.includes('contacts.html')) {
            $(".layui-nav-item").eq(2).addClass("layui-nav-itemed")
            $(".layui-nav-item").eq(2).children(".layui-nav-item-a").eq(0).addClass("layui-nav-item-a-active")
            $(".layui-nav-item").eq(2).find(".menu-title").eq(0).addClass("menu-title-active")
            let currentUrl = $(".layui-nav-item-a-active").children(".nav-item-dt").attr("src");
            currentUrl = currentUrl.split(".png")
            $(".layui-nav-item-a-active").children(".nav-item-dt").attr("src",`${currentUrl[0]}_active.png`);
          }
         
        },0)
    }
    
    function toggleHeighlight(menuConfig) {
      let LeftNav = [
        ["onlinePayment.html", "invoice.html", "billDownload.html"],
        ["peopleApply.html", "compApply.html", "businessGuide.html", "businessQuery.html", "waterReport.html", "waterReport.html", "waterReport.html", "separateAccount.html"],
        ["accountBinding.html", "waterAnalysis.html", "changePassword.html"],
        ["leakAndRepairs.html", "complaintreport.html", "businessOutlets.html"]
      ]
      const waterService = ["onlinePayment.html", "invoice.html", "billDownload.html"]
      const businessDeal = []
      const personalService = ["accountBinding.html", "waterAnalysis.html", "changePassword.html"]
      const publicService = []
      if(menuConfig[0]) {
        businessDeal.push('peopleApply.html')
      }
      if(menuConfig[1]) {
        businessDeal.push('compApply.html')
      }
      businessDeal.push('businessGuide.html')
      businessDeal.push('businessQuery.html')
      if(menuConfig[2]) {
        publicService.push('leakAndRepairs.html')
      }
      if(menuConfig[3]) {
        businessDeal.push('waterReport.html')
      }
      if(menuConfig[4]) {
        businessDeal.push('waterReport.html')
      }
      if(menuConfig[5]) {
        businessDeal.push('waterReport.html')
      }
      if(menuConfig[6]) {
        businessDeal.push('separateAccount.html')
      }
      publicService.push('complaintreport.html')
      publicService.push('businessOutlets.html')
      LeftNav = [waterService, businessDeal, personalService, publicService]
      // 左边菜单高亮
      setTimeout( function () {
        let href = window.location.pathname, childMenuIndex = null;
        let currentGroup = href.split('/');
        let currentIndex = currentGroup.filter(function(item) {
          return item.indexOf(".html")!== -1
        })
        
        LeftNav.forEach((item, index) => {
          if(currentIndex.length > 0 && item.indexOf(currentIndex[0]) !== -1) {
            childMenuIndex = item.indexOf(currentIndex[0]);
            if(currentIndex[0] === "waterReport.html"){
              let pageParmas = getRouterParams();
              switch(pageParmas.type) {
                case "5": childMenuIndex +=1;
                break;
                case "6": childMenuIndex +=2;
              }
            }
            $(".layui-nav-item").click(function(){//切换导航时清除之前设置的文字高亮
              $('.layui-nav-item-a-active').removeClass("layui-nav-item-a-active")
            })
            $(".layui-nav-item").eq(index).addClass("layui-nav-itemed")
            $(".layui-nav-item").eq(index).children(".layui-nav-item-a").eq(0).addClass("layui-nav-item-a-active")
            $(".layui-nav-item").eq(index).find(".menu-title").eq(childMenuIndex).addClass("menu-title-active")
            let currentUrl = $(".layui-nav-item-a-active").children(".nav-item-dt").attr("src");
            currentUrl = currentUrl.split(".png")
            $(".layui-nav-item-a-active").children(".nav-item-dt").attr("src",`${currentUrl[0]}_active.png`);
          }
        })
        if(href.includes('contacts.html')) {
          $(".layui-nav-item").eq(2).addClass("layui-nav-itemed")
          $(".layui-nav-item").eq(2).children(".layui-nav-item-a").eq(0).addClass("layui-nav-item-a-active")
          $(".layui-nav-item").eq(2).find(".menu-title").eq(0).addClass("menu-title-active")
          let currentUrl = $(".layui-nav-item-a-active").children(".nav-item-dt").attr("src");
          currentUrl = currentUrl.split(".png")
          $(".layui-nav-item-a-active").children(".nav-item-dt").attr("src",`${currentUrl[0]}_active.png`);
        }
      },0)
    }

    function logout() {
      layui.use('layer', function() {
        var layer = layui.layer
        layer.confirm('确认退出登录？',{title:'提示'}, function(index){
          var token = sessionStorage.getItem('token')
          if(!token) {
            return
          }
          var data = {
            token: token
          }
          var config = {
            data: data,
            url: '/common/logout',
            success: function(data) {
              if (data.code === 0) {
                layer.msg('退出登录成功', {
                  icon: 1
                })
                sessionStorage.removeItem('token')
                sessionStorage.removeItem('userInfo')
                sessionStorage.removeItem('groupCode')
                if(isHome()) {
                  window.location.reload()
                }else {
                  window.location.href = "../indexNew.html"
                }
              } else {
                layer.msg(data.description)
              }
            },
            error: function(data) {
              console.error(data)
            },
            isJson: true,
            dataType: 'json'
          }
          request(config)
        })
      })
    }
  
    function getUrls() {
      var params = getRouterParams()
      var code = params && params.code
      if (!code || code === '') {
        showNoCode()
        return
      }
      var data = {
        data: {
          code: code
        }
      }
      var config = {
        data: data,
        url: '/common/companyUrl',
        success: function(data) {
          if (data.code === 0) {
            // refreshLinks(data.data)
          } else {
            showNoCode()
          }
        },
        error: function(data) {
          console.error(data)
          showNoCode()
        },
        isJson: true,
        dataType: 'json'
      }
      request(config)
    }
  
  
    function showNoCode() {
      $('.bannarBackground').remove()
      $('.top-menu').remove()
      $('.header-tool').remove()
      $('.main-body').html(`<div class="no-code"><div class="link">您访问的页面不存在，请<a href="http://36.103.224.181:9043/indexNew.html?code=C000003">点击跳转</a>到门户首页</div></div>`)
    }

    function refreshMenu(menuConfig) {
      if(isHome()) {
        var config = {
          0: 'peopleApplyMenu',
          1: 'compApplyMenu',
          2: 'leakAndRepairsMenu',
          4: 'newWater',
          5: 'govGreen'
        }
        for(var key in menuConfig) {
          if(menuConfig[key]) {
            $('#'+ config[key]).show()
          } else {
            $('#'+ config[key]).hide()
          }
        }
      } else {
        const config = {
          0: 'peopleApply',
          1: 'compApply',
          2: 'leakAndRepairs',
          4: 'waterReport',
          5: 'waterReport',
          6: 'waterReport',
          7: 'separateAccount'
        }
        let flag = true
        for(var key in menuConfig) {
          if(config[key] === 'waterReport') {
            if(window.location.href.includes(config[key]) && window.location.href.includes('?type=' + key) && !menuConfig[key]) {
              window.location.replace('../indexNew.html')
              flag = false
              break
            }
          } else if(window.location.href.includes(config[key]) && !menuConfig[key]) {
            window.location.replace('../indexNew.html')
            flag = false
            break
          }
        }
        if(!flag) {
          return
        }
      const body = `
      <div class="left-nav">
        <ul class="layui-nav layui-nav-tree" lay-filter="leftNav" lay-shrink="all">
          <li class="layui-nav-item">
            <a href="javascript:;" class=" layui-nav-item-a" >
              <img src="../images/common/water.png" class="nav-item-dt" alt="">
              <span>用水服务</span>
            </a>
            <dl class="layui-nav-child">
              <dd><a class="menu-title" href="./onlinePayment.html">水费查缴</a></dd>
              <dd><a class="menu-title" href="./invoice.html">电子发票</a></dd>
              <dd><a class="menu-title" href="./billDownload.html">账单查询</a></dd>
            </dl>
          </li>
          <li class="layui-nav-item">
            <a href="javascript:;" class="layui-nav-item-a">
              <img src="../images/common/business.png" class="nav-item-dt" alt="">
              <span>业务办理</span>
            </a>
            <dl class="layui-nav-child">
              ${ menuConfig[0] ? '<dd><a class="menu-title" href="./peopleApply.html">居民用水申请</a></dd>' : ''}
              ${ menuConfig[1] ? '<dd><a class="menu-title" href="./compApply.html">企业用水申请</a></dd>' : ''}
              <dd><a class="menu-title" href="./businessGuide.html">业务指南</a></dd>
              <dd><a class="menu-title" href="./businessQuery.html">业务查询</a></dd>
              ${ menuConfig[4] ? '<dd><a class="menu-title" href="./waterReport.html?type=4">新装接水</a></dd>' : ''}
              ${ menuConfig[5] ? '<dd><a class="menu-title" href="./waterReport.html?type=5">市政绿化</a></dd>' : ''}
              ${ menuConfig[6] ? '<dd><a class="menu-title" href="./waterReport.html?type=6">施工临水</a></dd>' : ''}
              ${ menuConfig[7] ? '<dd><a class="menu-title" href="./separateAccount.html">分户改造</a></dd>' : ''}
            </dl>
          </li>
          <li class="layui-nav-item">
            <a href="javascript:;" class="layui-nav-item-a">
              <img src="../images/common/personal.png" class="nav-item-dt" alt="">
              <span>个人中心</span>
            </a>
            <dl class="layui-nav-child">
              <dd><a class="menu-title" href="./accountBinding.html">账号绑定</a></dd>
              <dd><a class="menu-title" href="./waterAnalysis.html">用水分析</a></dd>
              <dd><a class="menu-title" href="./changePassword.html">修改密码</a></dd>
            </dl>
          </li>
          <li class="layui-nav-item">
            <a href="javascript:;" class="layui-nav-item-a">
              <img src="../images/common/pservice.png" class="nav-item-dt" alt="">
              <span>公共服务</span>
            </a>
            <dl class="layui-nav-child">
            ${ menuConfig[2] ? '<dd><a class="menu-title" href="./leakAndRepairs.html">报修报漏</a></dd>' : ''}
              <dd><a class="menu-title" href="./complaintreport.html">我要留言</a></dd>
              <dd><a class="menu-title" href="./businessOutlets.html">营业网点</a></dd>
            </dl>
          </li>
        </ul>
      </div>`
      $('.body-left').html(body)
      toggleHeighlight(menuConfig)
      navInit();

      }
    }
  
    main()
    $('#logout').on('click', logout)

    $(".layui-nav-item-a").on("mouseover mouseout", function(event) {
      let currentUrl = $(this).children(".nav-item-dt").attr("src");
      if(event.type === "mouseover"){
        
        if(currentUrl.indexOf("_active") === -1){
          currentUrl = currentUrl.split(".png");
          $(this).children(".nav-item-dt").attr("src",`${currentUrl[0]}_active.png`)
        }
        
      }else if(event.type === "mouseout"){
        currentUrl = currentUrl.split("_active.png")
        if(!$(this).hasClass("layui-nav-item-a-active")) {
          $(this).children(".nav-item-dt").attr("src",`${currentUrl[0]}.png`)
        }
        
      }
    })
    function navInit () {
      setTimeout(function () {
        // 导航栏操作
        layui.use('element', function () {
          var element = layui.element; //导航的hover效果、二级菜单等功能，需要依赖element模块
          if (!isHome()) {
            //监听导航点击
            element.on('nav(leftNav)', function (elem) {
              let elGroup = $(".layui-nav-item-a");
              for (let i = 0; i < elGroup.length; i++) {
                let current = elGroup.eq(i).children(".nav-item-dt").attr("src");
                if (current && current.indexOf("_active") !== -1) {
                  current = current.split("_active.png")
                  elGroup.eq(i).children(".nav-item-dt").attr("src", `${current[0]}.png`)
                }

              }
              let currentUrl = elem.children(".nav-item-dt").attr("src");
              if (currentUrl && currentUrl.indexOf("_active") === -1) {
                currentUrl = currentUrl.split(".png")
                elem.children(".nav-item-dt").attr("src", `${currentUrl[0]}_active.png`);
              }
            });
          }
          element.init();
        });
      }, 500)
    }
    navInit();
    

  })()